import TopEventTypes from './TopEventTypes';

export default TopEventTypes;
